export const frontendSettings = JSON.parse(document.getElementById('frontend-settings-config').textContent);
